// extracted by mini-css-extract-plugin
module.exports = {"fadeInUp":"animation_fadeInUp__2DSux"};